import { render, staticRenderFns } from "./EditarNegocio.vue?vue&type=template&id=50881824&"
import script from "./EditarNegocio.vue?vue&type=script&lang=ts&"
export * from "./EditarNegocio.vue?vue&type=script&lang=ts&"
import style0 from "./EditarNegocio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports